import React from "react";
import { connect } from "react-redux";

/*
  STEP 7: We will import mapStateToProps and FloatingButtonsContainer from the core folder. Unlike for the custom SidebarContainer,
  this time we won't be making modifications to mapStateToProps since we have the values we already want to use. Thus, we can
  just import the existing one from core.
*/
import {
  mapStateToProps,
  FloatingButtonsContainer
} from "components/FloatingButtons/FloatingButtonsContainer";
import FloatingButtons from "components/FloatingButtons/FloatingButtons";

/*
  STEP 6:

  We will be removing the floating buttons from the page. To do so, we need the FloatingButtonsContainer.js or FloatingButtons.js to
  understand that it will not have floating buttons when (1) it is in the Project page, (2) when the Project ID is 3377.

  Likewise, we wouldn't want to do this by modifying `get floatingButtonsState()` in Pages.js. If you look at the `render()` function
  in core FloatingButtonsContainer.js, the PROJECT_ID variable is already provided for you to do your checks.

  Also, if you check `get floatingButtonsState()` in Pages.js, you will realize Topic Category and Project pages fall conveniently
  under "projecthome". We already have floatingButtonsState ready in mapStateToProps of core FloatingButtonsContainer.js for us
  to use.
*/
export class CustomFloatingButtonsContainer extends FloatingButtonsContainer {
  render() {
    const IS_MOBILE_PROJECT_PAGE = !!(
      this.state.isMobilePage &&
      this.props.floatingButtonsState === "projecthome"
    );
    const HAS_BUTTONS = !!this.props.buttons;
    const HAS_VALID_STATE = !!this.props.floatingButtonsState;
    const HAS_PROJECT = !!(this.props.project && this.props.project.id);
    const PROJECT_ID = this.props.project
      ? this.props.project.id || null
      : null;

    /*
      STEP 8: We modifying the `if` checks in the render() function so that it returns null when (1) it is in the Topic Category or
      Project page, and (2) Project Id is 3377.
    */
    /*
      Custom: modified existing if condition to check:
      (1) is Topic Category or Project page, and
      (2) is Project ID 3377
    */
    if (
      IS_MOBILE_PROJECT_PAGE ||
      !HAS_BUTTONS ||
      !HAS_VALID_STATE ||
      !HAS_PROJECT ||
      (this.props.floatingButtonsState === "projecthome" && PROJECT_ID === 3377)
    ) {
      return null;
    } else {
      return (
        <FloatingButtons
          buttons={this.props.buttons}
          projectId={PROJECT_ID}
          language={this.props.language}
        />
      );
    }
  }
}

export default connect(mapStateToProps)(CustomFloatingButtonsContainer);
